
import { type FC } from 'react'
import { Icon } from '@/components/ui/icon'
import { Button } from '@/components/ui/button'
import { Slider } from '@/components/ui/slider'

interface SliderParamProps {
  /** Label text */
  label: string
  /** Current value (as single-element array for Slider compatibility) */
  value: number[]
  /** Called with new value array */
  onChange: (value: number[]) => void
  /** Maximum value */
  max: number
  /** Minimum value */
  min?: number
  /** Step for +/- buttons */
  step?: number
  /** Unit suffix displayed after the value (e.g. "%") */
  unit?: string
}

export const SliderParam: FC<SliderParamProps> = ({
  label,
  value,
  onChange,
  max,
  min = 0,
  step = 10,
  unit = '%',
}) => {
  return (
    <div className="flex flex-col gap-2 px-0 py-2">
      <div className="flex items-center gap-2 px-2">
        <span className="text-sm flex-1">{label}</span>
        <div className="flex items-center gap-2 flex-1 justify-end">
          <Button
            size="icon-sm"
            variant="ghost"
            className="h-7 w-[10.67px]"
            onClick={() => onChange([Math.max(min, value[0] - step)])}
          >
            <Icon name="minus" className="h-3 w-3" />
          </Button>
          <div className="flex items-center justify-center h-7 px-3 py-1 bg-background border border-border rounded-md min-w-[60px]">
            <span className="text-sm text-center">
              {value[0]}
              {unit}
            </span>
          </div>
          <Button
            size="icon-sm"
            variant="ghost"
            className="h-7 w-4"
            onClick={() => onChange([Math.min(max, value[0] + step)])}
          >
            <Icon name="plus" className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <div className="px-2">
        <Slider value={value} onValueChange={onChange} min={min} max={max} />
      </div>
    </div>
  )
}
